var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("collapse", { attrs: { title: "Renovación del contrato" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md" },
            [
              _c("label", { staticClass: "data-label" }, [
                _vm._v(
                  " El artículo 19 de la Guía estable que las renovaciones de contratos cuyos servicios hayan sido procurados mediante procesos competitivos podrán realizarse por un período de hasta cinco años "
                )
              ]),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ validated }) {
                      return [
                        _c("custom-radio", {
                          staticClass: "custom-radio",
                          attrs: {
                            "custom-error-msg": "El campo es requerido.",
                            disabled: _vm.isReadOnly,
                            "is-inline": "",
                            label: "¿Los servicios podrán ser renovados?",
                            name: "canRenewal",
                            options: _vm.options
                          },
                          on: { input: _vm.onCanRenewalChange },
                          model: {
                            value: _vm.canRenewal,
                            callback: function($$v) {
                              _vm.canRenewal = $$v
                            },
                            expression: "canRenewal"
                          }
                        }),
                        validated &&
                        ![true, false].includes(_vm.canRenewal?.value)
                          ? _c("error", {
                              attrs: {
                                message: "El campo es requerido.",
                                variant: "no-border"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm.canRenewal?.value
          ? _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col" }, [
                _c("label", {}, [_vm._v(" ¿Por cuánto tiempo? ")])
              ])
            ])
          : _vm._e(),
        _vm.canRenewal?.value
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-2" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required|min_value:1" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "renewalDuration",
                                  "custom-error-msg":
                                    "El campo es requerido y debe ser mayor a 0",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  min: 0,
                                  type: "number"
                                },
                                model: {
                                  value: _vm.model.renewalDuration,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "renewalDuration",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.renewalDuration"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3794213797
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md-2" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  id: "renewalDurationType",
                                  clearable: false,
                                  "custom-error-msg": "El campo es requerido",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.renewalDurationTypes,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.renewalDurationType,
                                  callback: function($$v) {
                                    _vm.renewalDurationType = $$v
                                  },
                                  expression: "renewalDurationType"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3600900915
                    )
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }